<template>
    <div class="dynamic-table table-responsive p-2">
        <form>

            <TabView :scrollable="true" v-if="data.table_columns_forlang !== undefined && data.table_columns_forlang.length">
                <TabPanel v-for="li in G.lang_list" :key="li.value">
                    <template #header>
                        <span class="me-2">{{ li.flag }}</span>
                        <span>{{ li.label }}</span>
                    </template>

                    <template v-for="(item, index) in data.table_columns_forlang" :key="index">

                        <div class="mb-1 p-1" v-if="item.private !== undefined && typeof item.private === 'function' ? (item.private(data, PO) === false ? true : false) : (item.private === undefined || item.private === false ? true : false)">

                            <div class="mb-1 fw-bold" v-if="G.userHavePermission(data.data.permission_method) || (item.field_type != 'image' && item.field_type != 'file')" v-html="item.title + ' (' + li.label + ')'"></div>

                            <div class="mb-1" v-if="G.userHavePermission(data.data.permission_method)">
                                <InputText
                                    v-if="item.field_type == 'text'"
                                    v-model="PO['newdata'][item.name][li.value]"
                                    type="text"
                                    :class="item.class + (item.required && (PO['newdata'][item.name][li.value] === undefined || PO['newdata'][item.name][li.value] === '') ? ' required' : '')"
                                    :placeholder="item.placeholder || item.title || ''" :[item.attr]="item.attrValue"
                                />
                                <Textarea v-else-if="item.field_type == 'textarea'"
                                    v-model="PO['newdata'][item.name][li.value]"
                                    :autoResize="false"
                                    :class="item.class + (item.required && (PO['newdata'][item.name][li.value] === undefined || PO['newdata'][item.name][li.value] === null) ? ' required' : '')"
                                    :rows="item.text_rows !== undefined ? item.text_rows : 3"
                                    :cols="item.text_cols !== undefined ? item.text_cols : 20"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    class="form-control"
                                />
                            </div>
                            <span class="mb-2" v-else v-html="typeof item.value === 'function' ? item.value(data.data.translate.filter(b => b.lang_id == li.value)) : data.data[item.value]"></span>

                        </div>

                    </template>
                </TabPanel>
            </TabView>

            <!-- <div class="d-flex justify-content-center mb-4" v-if="data.table_columns_forlang !== undefined && data.table_columns_forlang.length">
                <hr />
            </div> -->

            <table class="table">
                <thead v-if="data.table_columns_forlang === undefined || !data.table_columns_forlang.length">
                    <tr class="table-light1 text-dark1 border-secondary1">
                        <th class="fw-bold" style="width: 30%;"></th>
                        <th class="fw-bold"></th>
                    </tr>
                </thead>
                <tbody v-if="data.table_columns">
                    <template v-for="(item, index) in data.table_columns" :key="index">
                        <tr v-if="item.private !== undefined && typeof item.private === 'function' ? (item.private(data, PO) === false ? true : false) : (item.private === undefined || item.private === false ? true : false)">
                            <td class="fw-bold1 align-middle" v-if="G.userHavePermission(data.data.permission_method) || (item.field_type != 'image' && item.field_type != 'file')" v-html="item.title"></td>

                            <td v-if="G.userHavePermission(data.data.permission_method)" class="align-middle">
                                <Image
                                    v-if="item.name == 'preview_image' && item.field_type == 'label'"
                                    :src="PO['newdata'][item.name]"
                                    :alt="TR.image"
                                    height="90"
                                    :preview="true"
                                />
                                <div v-else-if="item.field_type == 'image'" class="d-flex flex-sm-row1 flex-column text-nowrap align-items-start">
                                    <FileUpload
                                        v-model="PO['newdata'][item.name]"
                                        :mode="item.fileSelectMode"
                                        name="images[]"
                                        :customUpload="true"
                                        @select="onFileChanged($event, item.name)"
                                        accept="image/*"
                                        :multiple="item.fileMultiple || false"
                                        :maxFileSize="item.fileMaxSize"
                                        :fileLimit="item.fileLimit || false"
                                        :invalidFileSizeMessage="TR.invalidFileSizeMessage"
                                        :invalidFileLimitMessage="TR.invalidFileLimitMessage"
                                        :uploadLabel="item.uploadLabel || TR.upload"
                                        :chooseLabel="item.chooseLabel || TR.select_file"
                                    >
                                        <template #empty>
                                            <p>{{TR.drag_file}}</p>
                                        </template>
                                    </FileUpload>
                                    <span class="mx-2">{{TR.or}}</span>
                                    <InputText
                                        v-model="PO['newdata'][item.name]"
                                        type="text"
                                        class=""
                                        @change="onImageChanged($event, item.name)"
                                        :placeholder="TR.link"
                                    />
                                </div>
                                <div v-else-if="item.field_type == 'file'">
                                    <FileUpload
                                        v-model="PO['newdata'][item.name]"
                                        :mode="item.fileSelectMode"
                                        name="images[]"
                                        :customUpload="true"
                                        @select="onFileChanged($event, item.name)"
                                        :accept="item.accept !== undefined ? item.accept : ''"
                                        :multiple="item.fileMultiple || false"
                                        :maxFileSize="item.fileMaxSize"
                                        :fileLimit="item.fileLimit || 1"
                                        :invalidFileSizeMessage="TR.invalidFileSizeMessage"
                                        :invalidFileLimitMessage="TR.invalidFileLimitMessage"
                                        :uploadLabel="item.uploadLabel || TR.upload"
                                        :chooseLabel="item.chooseLabel || TR.select_file"
                                    >
                                        <template #empty>
                                            <p>{{TR.drag_file}}</p>
                                        </template>
                                    </FileUpload>
                                    <span class="mx-2">{{TR.or}}</span>
                                    <InputText
                                        v-model="PO['newdata'][item.name]"
                                        type="text"
                                        class=""
                                        @change="onImageChanged($event, item.name)"
                                        :placeholder="TR.link"
                                    />
                                </div>
                                <InputText
                                    v-else-if="item.field_type == 'text'"
                                    v-model="PO['newdata'][item.name]"
                                    type="text"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === '') ? ' required' : '')"
                                    :placeholder="item.placeholder || item.title || ''" :[item.attr]="item.attrValue"
                                />
                                <InputText v-else-if="item.field_type == 'password'" v-model="PO['newdata'][item.name]" type="password" :class="item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === '') ? 'required' : ''"
                                    :placeholder="item.placeholder || item.title || ''" :[item.attr]="item.attrValue"
                                />
                                <InputNumber v-else-if="item.field_type == 'integer'"
                                    v-model="PO['newdata'][item.name]"
                                    integeronly
                                    mode="decimal"
                                    :step="item.step !== undefined ? item.step : 1"
                                    showButtons
                                    buttonLayout="horizontal"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :useGrouping="item.grouping !== undefined && item.grouping == true ? true : false"
                                    :min="item.min !== undefined ? item.min : 0"
                                    :max="item.max !== undefined ? item.max : undefined"
                                    :suffix="item.suffix !== undefined ? item.suffix : undefined"
                                    :prefix="item.prefix !== undefined ? item.prefix : undefined"
                                    :placeholder="item.placeholder || item.title || ''" :[item.attr]="item.attrValue"
                                >
                                    <template #incrementbuttonicon>
                                        <span class="fas fa-plus" />
                                    </template>
                                    <template #decrementbuttonicon>
                                        <span class="fas fa-minus" />
                                    </template>
                                </InputNumber>
                                <InputNumber v-else-if="item.field_type == 'numeric'"
                                    v-model="PO['newdata'][item.name]"
                                    :step="item.step !== undefined ? item.step : 1"
                                    showButtons
                                    buttonLayout="horizontal"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :useGrouping="item.grouping !== undefined && item.grouping == true ? true : false"
                                    :min="item.min !== undefined ? item.min : 0"
                                    :max="item.max !== undefined ? item.max : undefined"
                                    :suffix="item.suffix !== undefined ? item.suffix : undefined"
                                    :prefix="item.prefix !== undefined ? item.prefix : undefined"
                                    :minFractionDigits="item.minFraction !== undefined ? item.minFraction : 2"
                                    :maxFractionDigits="item.maxFraction !== undefined ? item.maxFraction : 3"
                                    :placeholder="item.placeholder || item.title || ''" :[item.attr]="item.attrValue"
                                >
                                    <template #incrementbuttonicon>
                                        <span class="fas fa-plus" />
                                    </template>
                                    <template #decrementbuttonicon>
                                        <span class="fas fa-minus" />
                                    </template>
                                </InputNumber>
                                <InputNumber v-else-if="item.field_type == 'currency'"
                                    v-model="PO['newdata'][item.name]"
                                    mode="currency"
                                    :step="item.step !== undefined ? item.step : 1"
                                    showButtons
                                    buttonLayout="horizontal"
                                    :currency="store.getCurrency()"
                                    :locale="`${store.getLang()}-${store.getLang().toUpperCase()}`"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :useGrouping="item.grouping !== undefined && item.grouping == true ? true : false"
                                    :min="item.min !== undefined ? item.min : 0"
                                    :max="item.max !== undefined ? item.max : undefined"
                                    :suffix="item.suffix !== undefined ? item.suffix : undefined"
                                    :prefix="item.prefix !== undefined ? item.prefix : undefined"
                                    :minFractionDigits="item.minFraction !== undefined ? item.minFraction : 2"
                                    :maxFractionDigits="item.maxFraction !== undefined ? item.maxFraction : 3"
                                    :placeholder="item.placeholder || item.title || ''" :[item.attr]="item.attrValue"
                                >
                                    <template #incrementbuttonicon>
                                        <span class="fas fa-plus" />
                                    </template>
                                    <template #decrementbuttonicon>
                                        <span class="fas fa-minus" />
                                    </template>
                                </InputNumber>
                                <InputMask v-else-if="item.field_type == 'mask'" v-model="PO['newdata'][item.name]" :mask="item.input_mask !== undefined && item.input_mask != '' ? item.input_mask : '9'"
                                    :placeholder="item.input_mask !== undefined && item.input_mask != '' ? item.input_mask : '9'"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')" :[item.attr]="item.attrValue" />
                                <!-- <ColorPicker v-else-if="item.field_type == 'color'" v-model="PO['newdata'][item.name]" defaultColor="{'r':128,'g':22,'b':22}" style="background-color: var(--bs-primary-rgb);" format="rgb" :class="item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? 'required' : ''" :placeholder="item.placeholder || item.title || ''" -->
                                <ColorPicker v-else-if="item.field_type == 'color'" v-model="PO['newdata'][item.name]" defaultColor="03446c" format="rgb" :placeholder="item.placeholder || item.title || ''" />

                                <div v-else-if="item.field_type == 'switch'" class="form-check form-switch" :class="item.class">
                                    <input
                                        v-model="PO['newdata'][item.name]"
                                        :id="`${item.name}_switch`"
                                        class="form-check-input cursor-pointer"
                                        :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                        @[item.event]="item.callback !== undefined ? item.callback($event, item, PO) : null"
                                        type="checkbox"
                                        role="switch"
                                        :placeholder="item.placeholder || item.title || ''"
                                    />
                                    <label class="form-check-label" :for="`${item.name}_switch`"></label>
                                </div>

                                <Textarea v-else-if="item.field_type == 'textarea'"
                                    v-model="PO['newdata'][item.name]"
                                    :autoResize="false"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :rows="item.text_rows !== undefined ? item.text_rows : 3"
                                    :cols="item.text_cols !== undefined ? item.text_cols : 20"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    class="form-control"
                                ></Textarea>
                                <Calendar v-else-if="item.field_type == 'date'"
                                    v-model="PO['newdata'][item.name]"
                                    :dateFormat="item.filter_format"
                                    :maxDate="item.maxDate || null"
                                    :minDate="item.minDate || null"
                                    :showTime="item.showTime === undefined ? true : item.showTime"
                                    :showSeconds="item.showSeconds === undefined ? true : item.showSeconds"
                                    :stepMinute="item.stepMinute === undefined ? 1 : item.stepMinute"
                                    :hideOnDateTimeSelect="true"
                                    :showButtonBar="true"
                                    :placeholder="item.placeholder || item.title || 'dd.mm.yyyy'"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :[item.attr]="item.attrValue"
                                    @update:modelValue="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                />
                                <Calendar v-else-if="item.field_type == 'time'"
                                    v-model="PO['newdata'][item.name]"
                                    :showTime="item.showTime === undefined ? true : item.showTime"
                                    :showSeconds="item.showSeconds === undefined ? true : item.showSeconds"
                                    :stepMinute="item.stepMinute === undefined ? 1 : item.stepMinute"
                                    :timeOnly="true"
                                    hourFormat="24"
                                    :hideOnDateTimeSelect="true"
                                    :placeholder="item.placeholder || item.title || 'hh:mm:ss'"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :[item.attr]="item.attrValue"
                                    @update:modelValue="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                />
                                <Dropdown v-else-if="item.field_type == 'selectbox'"
                                    v-model="selectedItem[item.name]"
                                    :options="item.selectbox_items"
                                    optionValue="label"
                                    optionLabel="label"
                                    :editable="true"
                                    :showClear="item.showClear !== undefined && item.showClear == true ? true : false"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :[item.attr]="item.attrValue"
                                    @change="PO['newdata'][item.name] = selectedItem[item.name]; ( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                    @input="PO['newdata'][item.name] = selectedItem[item.name]; (item.onInput !== undefined && typeof item.onInput == 'function' ? item.onInput($event, item) : null);"
                                />
                                <Dropdown v-else-if="item.field_type == 'dropdown'"
                                    v-model="selectedItem[item.name]"
                                    :options="item.dropdown_items"
                                    optionValue="value"
                                    optionLabel="label"
                                    :placeholder="item.placeholder || TR.select"
                                    :filter="item.dropdown_items.length > 10 ? true : false"
                                    :class="( item.class || '' ) + (item.required !== undefined && item.required === true && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null || PO['newdata'][item.name] == 0) ? ' required' : '')"
                                    :showClear="item.showClear !== undefined && item.showClear == true ? true : false"
                                    :[item.attr]="item.attrValue"
                                    @change="PO['newdata'][item.name] = selectedItem[item.name]; ( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                    @input="PO['newdata'][item.name] = selectedItem[item.name]; (item.onInput !== undefined && typeof item.onInput == 'function' ? item.onInput($event, item) : null);"
                                >
                                    <template #value="slotProps">
                                        <div
                                            :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.value) : item.dropdown_item_class"
                                            v-if="slotProps.value"
                                            v-html="(item.dropdown_items.filter((e) => e.value == slotProps.value)[0]?.icon ?? '') + ' ' + item.dropdown_items.filter((e) => e.value == slotProps.value)[0]?.label"
                                        ></div>
                                        <span v-else>{{slotProps.placeholder}}</span>
                                    </template>
                                    <template #option="slotProps">
                                        <div
                                            :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.option.value) : item.dropdown_item_class"
                                            v-html="(slotProps.option.icon ?? '') + (slotProps.option.icon ? ' ' : '' ) + slotProps.option.label"
                                        ></div>
                                    </template>
                                </Dropdown>
                                <Dropdown v-else-if="item.field_type == 'dropdown_group'"
                                    v-model="selectedItem[item.name]"
                                    :options="item.dropdown_items"
                                    optionValue="value"
                                    optionLabel="label"
                                    :placeholder="item.placeholder || TR.select"
                                    :filter="item.dropdown_items.length > 10 ? true : false"
                                    :class="( item.class || '' ) + (item.required !== undefined && item.required === true && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null || PO['newdata'][item.name] == 0) ? ' required' : '')"
                                    :showClear="item.showClear !== undefined && item.showClear == true ? true : false"
                                    :[item.attr]="item.attrValue"
                                    @change="PO['newdata'][item.name] = selectedItem[item.name]; ( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                    @input="PO['newdata'][item.name] = selectedItem[item.name]; (item.onInput !== undefined && typeof item.onInput == 'function' ? item.onInput($event, item) : null);"
                                    :optionGroupLabel="item.grouping !== undefined && item.grouping == true ? item.groupLabelField : ''"
                                    :optionGroupChildren="item.grouping !== undefined && item.grouping == true ? item.groupItemsField : ''"
                                >
                                    <template v-if="item.grouping !== undefined && item.grouping == true" #optiongroup="slotProps">
                                        <div v-html="(slotProps.option.icon ?? '') + (slotProps.option.icon ? ' ' : '' ) + slotProps.option.label"></div>
                                    </template>
                                </Dropdown>
                                <template v-else-if="item.field_type == 'multiselect'">
                                    <MultiSelect
                                        v-model="selectedItem[item.name]"
                                        :options="item.dropdown_items"
                                        optionValue="value"
                                        optionLabel="label"
                                        :filter="item.filter !== undefined && item.filter == true ? true : (item.dropdown_items.length > 10 ? true : false)"
                                        :placeholder="item.placeholder || TR.select"
                                        :class="( item.class || '' ) + (item.required !== undefined && item.required === true && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null || PO['newdata'][item.name] == 0) ? ' required' : '')"
                                        :maxSelectedLabels="1"
                                        @change="PO['newdata'][item.name] = selectedItem[item.name]; ( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                        :selectedItemsLabel="`{0} ${TR.group.toLowerCase()} ${TR.selected.toLowerCase()}`"
                                    >
                                        <!-- :pt="{
                                            labelContainer: {
                                                onChange: () => '{0} items secilib'
                                            }
                                        }" -->
                                        <!-- display="chip" -->

                                        <template #option="slotProps">
                                            <div
                                                :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.option.value) : item.dropdown_item_class"
                                                v-html="(slotProps.option.icon ? `${slotProps.option.icon} ` : '' ) + slotProps.option.label"
                                            ></div>
                                        </template>

                                        <!-- <template #footer>
                                            <div class="py-2 px-3 border-top">
                                                <b>{{ selectedItem[item.name] ? selectedItem[item.name].length : 0 }}</b> {{ TR.selected }}
                                            </div>
                                        </template> -->

                                    </MultiSelect>

                                    <Listbox :options="selectedItem[item.name]" style="max-height: 100px; overflow: hidden; overflow-y: auto; width: 16rem;" class="bg-light">
                                        <template #option="slotProps">
                                            <div class="flex align-items-center">
                                                <div v-html="item.dropdown_items.filter(f => f.value == slotProps.option).length ? item.dropdown_items.filter(f => f.value == slotProps.option)[0].label : `<b class='text-danger fst-italic'>-- ID: (${slotProps.option}) ${TR.filter_disabled} --</b>` "></div>
                                            </div>
                                        </template>
                                    </Listbox>

                                </template>

                                <!-- <Teleport v-else-if="item.field_type == 'text_content'" to="body">
                                    <SecondModal :mainref="mainref" :show="showModal" :title="editor.title" :width="70" :toolbar="editor" :data="editor.data" @close="onModalClose" />
                                </Teleport> -->

                                <span v-else v-html="typeof item.value === 'function' ? item.value(data.data, data) : data.data[item.value]"></span>

                                <!-- <template v-for="(btn, bindex) in item.buttons" :key="bindex">
                                        <button
                                            :class="`ms-2 me-sm-2 btn ${btn.class || 'btn-primary'}`"
                                            :title="btn.title !== undefined ? btn.title : ''"
                                            @click="$event.preventDefault(); showModal = true;"
                                        >
                                            <i :class="`me-1 ${btn.icon}`"></i>
                                            {{btn.label}}
                                        </button>{{btn}}
                                        <Teleport to="body">
                                            <SecondModal :show="showModal" :mainref="mainref" :data="btn" @close="showModal = false">
                                                <template #header>
                                                    custom header
                                                </template>
                                            </SecondModal>
                                        </Teleport> -->
                                    <!-- <button
                                        :class="`ms-2 me-sm-2 btn ${btn.class || 'btn-primary'}`"
                                        :title="btn.title !== undefined ? btn.title : ''"
                                        @click="btn.command(data, $event)"
                                    >
                                        <i :class="`me-1 ${btn.icon}`"></i>
                                        {{btn.label}}
                                    </button> -->
                                <!-- </template> -->




                            <!-- <div
                                v-if="item.buttons !== undefined && item.field_type == 'element' && (data.data.editable === undefined || data.data.editable == true)"
                                :class="item.class"
                            > -->
                            <!-- <div v-if="(item.private !== undefined && typeof item.private === 'function' ? item.private(data) === false ? true : false : (item.private === undefined || item.private === false ? true : false)) && item.buttons !== undefined && item.field_type == 'element' && (data.data.editable === undefined || data.data.editable == true)" :class="item.class"> -->

                                <template v-if="item.buttons !== undefined && item.field_type == 'element' && (data.data.editable === undefined || data.data.editable == true)">
                                    <template v-for="(el, elind) in item.buttons" :key="elind">
                                        <!-- <div> -->
                                            <div v-if="el.type == 'switch'" :class="el.class" class="form-check form-switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false">
                                                <input
                                                    class="form-check-input"
                                                    @[el.event]="el.callback($event, item.data, PO)"
                                                    type="checkbox"
                                                    role="switch"
                                                    :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false"
                                                />
                                            </div>
                                        <!-- </div> -->
                                        <input
                                            v-else-if="el.type == 'checkbox'"
                                            class="form-check-input"
                                            :class="el.class"
                                            @[el.event]="el.callback($event, item.data, PO)"
                                            type="checkbox"
                                            role="switch"
                                            :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false"
                                        />
                                        <input
                                            v-else-if="el.type == 'text'"
                                            class="form-control"
                                            :class="el.class"
                                            @[el.event]="el.callback($event, item.data, PO)"
                                            type="text"
                                            :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false"
                                        />
                                        <button
                                            v-else-if="el.type == 'button' && (item.btn_visible && typeof item.btn_visible === 'function' ? item.btn_visible(item.data) : item.btn_visible !== undefined ? item.btn_visible : true)"
                                            :class="el.class"
                                            @[el.event]="el.callback($event, item.data, PO)"
                                            :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false"
                                        >
                                            <i v-if="el.icon" :class="el.icon"></i>
                                            <span>{{el.text}}</span>
                                        </button>
                                    </template>
                                </template>
                            <!-- </div> -->
                            <!-- <div v-else="" v-html="(item.value && typeof item.value === 'function' ? item.value(data.data) : item.value !== undefined ? item.value : true)"></div> -->


                            </td>

                            <td v-else-if="item.field_type != 'image' && item.field_type != 'file'">
                                <Image
                                    v-if="item.name == 'preview_image' && item.field_type == 'label'"
                                    :src="PO['newdata'][item.name]"
                                    :alt="TR.image"
                                    height="90"
                                    :preview="false"
                                />
                                <span v-else v-html="typeof item.value === 'function' ? item.value(data.data, data) : data.data[item.value]"></span>
                            </td>
                            <!-- <td v-else v-html="typeof item.value === 'function' ? item.value(data.data) : data.data[item.value]"></td> -->

                        </tr>
                    </template>

                </tbody>
            </table>
        </form>
    </div>

</template>


<script>
    import { ref, onMounted, watchEffect } from "vue";

    import { useStore } from "@/store";

    import { G } from "@/_common";

    import { useModelWrapper } from "@/utils/modelWrapper";

    import Dropdown from "primevue/dropdown";
    import InputText from "primevue/inputtext";
    import Textarea from "primevue/textarea";
    import InputNumber from "primevue/inputnumber";
    import InputMask from "primevue/inputmask";
    import Calendar from "primevue/calendar";
    import FileUpload from "primevue/fileupload";
    import Image from "primevue/image";
    import ColorPicker from 'primevue/colorpicker';
    import TabView from 'primevue/tabview';
    import TabPanel from 'primevue/tabpanel';
    import MultiSelect from 'primevue/multiselect';
    import Listbox from 'primevue/listbox';


    export default {
        name: 'DynamicTable2',
        props: {
            data: {
                type: Object,
                default(){
                    return null;
                }
            },
            mainref: {
                type: Object,
                default(){
                    return null;
                }
            },
        },
        components: {
            // SecondModal,
            Dropdown,
            InputText,
            Textarea,
            InputNumber,
            InputMask,
            Calendar,
            FileUpload,
            Image,
            ColorPicker,
            TabView,
            TabPanel,
            MultiSelect,
            Listbox,
        },
        setup(props, { emit }) {
            const store = useStore();

            const TR = ref({});
            const PO = useModelWrapper(props, emit, "mainref");
            const selectedItem = ref({});
            PO.value['newdata'] = {};

            const showModal = ref(false);
            // const editor = ref({data: {editorData: ''}});

            const onFileChanged = (e, field_name) => {
                if (e.files) {
                    let a = false;
                    if( props.data.table_columns ){
                        props.data.table_columns.forEach((item) => {
                            if(item.name == field_name && item.fileMultiple){
                                a = true;
                                PO.value['newdata'][field_name] = e.files;
                            }
                            else if( item.name == field_name ){
                                PO.value['newdata'][field_name] = e.files[0];
                            }
                        });
                    }
                    if(!a){
                        PO.value['newdata'][field_name] = e.files[0];
                    }
                    PO.value['newdata']["preview_image"] = e.files[0].objectURL;
                    // props.data['preview_image'] = e.files[0].objectURL;
                }
            };

            const onImageChanged = (event) => {
                PO.value["preview_image"] = event.target.value;
            };

            watchEffect(() => {
                TR.value = store.getTranslation();
                // props.data.table_columns.forEach((item) => {
                    // if( item.name == 'preview_image' && typeof item.field_type !== undefined && item.field_type == 'label' ){
                    //     PO.value[item.name] = (typeof item.value === 'function' ? item.value(props.data.data) : props.data.data[item.value]);
                    //     // props.data.data[item.name] = (typeof item.value === 'function' ? item.value(props.data.data) : props.data.data[item.value]);
                    // }
                    // if( typeof item.field_type !== undefined && item.field_type != 'label' ){
                    //     PO.value[item.name] = (typeof item.value === 'function' ? item.value(props.data.data) : props.data.data[item.value]);
                    // }
                    // if( item.dropdown_item_selected !== undefined )
                    //     selectedItem.value[item.name] = item.dropdown_item_selected;
                // });
            // });

            // onMounted(() => {
                if( props.data.table_columns_forlang ){
                    props.data.table_columns_forlang.forEach((item) => {
                        if ( typeof item.field_type !== undefined && item.field_type != "label" ) {
                            G.lang_list.forEach((a) => {
                                if( PO.value['newdata'][item.name] === undefined ){
                                    PO.value['newdata'][item.name] = {};
                                }
                                let ldata = props.data.data.translate ? props.data.data.translate.filter( b => b.lang_id == a.value) : [];
                                PO.value['newdata'][item.name][a.value] =
                                    typeof item.value === "function"
                                        ? item.value(ldata.length ? ldata[0] : {[item.name]: ""})
                                        : props.data.data[item.value];
                            });
                        }
                    });
                }
                if( props.data.table_columns ){
                    props.data.table_columns.forEach((item) => {
                        if (
                            item.name == "preview_image" &&
                            typeof item.field_type !== undefined &&
                            item.field_type == "label"
                        ) {
                            PO.value['newdata'][item.name] =
                                typeof item.value === "function"
                                    ? item.value(props.data.data, props.data)
                                    : props.data.data[item.value];
                            // props.data.data[item.name] = (typeof item.value === 'function' ? item.value(props.data.data) : props.data.data[item.value]);
                        }
                        if (
                            typeof item.field_type !== undefined &&
                            item.field_type != "label"
                        ) {
                            PO.value['newdata'][item.name] =
                                typeof item.value === "function"
                                    ? item.value(props.data.data, props.data)
                                    : props.data.data[item.value];
                        }

                        if (item.dropdown_item_selected !== undefined){
                            selectedItem.value[item.name] = ( typeof item.field_type !== undefined && item.field_type == "multiselect" ) ? [...item.dropdown_item_selected] : item.dropdown_item_selected;
                            PO.value['newdata'][item.name] = item.dropdown_item_selected;
                        }
                        if (item.selectbox_item_selected !== undefined){
                            selectedItem.value[item.name] = ( typeof item.field_type !== undefined && item.field_type == "multiselect" ) ? [...item.selectbox_item_selected] : item.selectbox_item_selected;
                            PO.value['newdata'][item.name] = item.selectbox_item_selected;
                        }
                        if (item.default !== undefined){
                            selectedItem.value[item.name] = ( typeof item.field_type !== undefined && item.field_type == "multiselect" ) ? [...item.selectbox_item_selected] : item.default;
                            PO.value['newdata'][item.name] = item.default;
                        }
                    });
                }
            });

            const selectedCountries = ref({});
            const countries = ref([
                { name: 'Australia', code: 'AU' },
                { name: 'Brazil', code: 'BR' },
                { name: 'China', code: 'CN' },
                { name: 'Egypt', code: 'EG' },
                { name: 'France', code: 'FR' },
                { name: 'Germany', code: 'DE' },
                { name: 'India', code: 'IN' },
                { name: 'Japan', code: 'JP' },
                { name: 'Spain', code: 'ES' },
                { name: 'United States', code: 'US' }
            ]);

            return {
                G,
                TR,
                store,
                PO,
                selectedItem,
                onFileChanged,
                onImageChanged,
                showModal,

                selectedCountries,
                countries,
                // editor,
            };
        },
    };
</script>


<style lang="scss" scoped>
.dynamic-table{
    .modal-backdrop{
        z-index: 9;
    }
    .table {
        width: 100%;
        margin-bottom: 1rem;
        // color: #7b809a;
        vertical-align: top;
        border-color: #f0f2f5;
    }
    .table thead th {
        // padding: .75rem 1.5rem;
        letter-spacing: 0;
        border-bottom: 1px solid #f0f2f5;
        border-bottom-color: rgb(240, 242, 245);
        text-transform: uppercase !important;
        color: var(--bs-secondary);
    }
    .table > :not(:first-child) {
        border-top: 1px solid currentColor;
    }
    .table.align-items-center td,
    .table.align-items-center th {
        vertical-align: middle;
    }
    .p-dropdown, .p-multiselect {
        width: 16rem;
    }
    .required{
        border: 1px solid #ff0000;
        border-radius: 5px;
    }
    .p-image-toolbar{
        z-index: 9999;
        background: rgba(190, 190, 190, 0.5);
    }
    .p-image-preview{
        background-color: #fff;
        height: 90%;
    }
    .p-multiselect .p-highlight {
        background: transparent !important;
    }
    textarea::placeholder{
        color: rgba(var(--bs-secondary-rgb), .5) !important;
    }
}
</style>

